export default __webpack_public_path__ + "static/media/boMain.1f6e7a82.png";